import React, { useContext, useEffect, useState } from 'react';
import { useHistory, withRouter, useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { getAllBikesByStationId, removeBike } from '../../../models/actions/Bikes';
import { findStationById } from '../../../models/actions/Stations';
import '../../../App.css';
import compose from 'recompose/compose';
import SpIconAndTextButton from '../../../components/atoms/SpIconAndTextButton';
import SpText from '../../../components/atoms/SpText';
import SpButton from '../../../components/atoms/SpButton';
import SpIconButton from '../../../components/atoms/SpIconButton';
import SpSearch from '../../../components/atoms/SpSearch';
import { SpTable, SpTableCell, SpTableRow } from '../../../components/bundles/SpTable';
import { styled } from '../../../components/styled';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { Grid, TableCell } from '@material-ui/core';
import { labels } from '../../shared/translations';
import { withSnackbar } from '../../../components/atoms/SpSnackBar';
import { ArrowBack, DeleteForever } from '@material-ui/icons';
import SpDialog from '../../../components/atoms/SpDialog';
import { theme } from '../../../components/theme';
import moment from 'moment';
import { UserSessionContext } from '../../../App';

const AdminStationBikes = (props) => {
  const [searchString, setSearchString] = useState();
  const [ebikesList, setEbikes] = useState([]);
  const [displayEbike, setDisplayEbike] = useState([]);
  const [openDeleteEbike, setOpenDeleteEbike] = useState(false);
  const [currentStation, setCurrentStation] = useState();
  const [selectedBikeId, setSelectedBikeId] = useState();
  const { authData, setAuthData } = useContext(UserSessionContext);

  const history = useHistory();
  const { stationId } = useParams();

  const fetchData = async () => {
    props.isLoading(true);
    try {
      const response = await getAllBikesByStationId({ id_station: stationId }, authData.accessToken);
      response && setEbikes(response);
      response && setDisplayEbike(response);
      const responseStation = await findStationById({ id_station: stationId }, authData.accessToken);
      setCurrentStation(responseStation);
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
    props.isLoading(false);
  };

  const filterEbikes = (e) => {
    let newDisplayFilters = ebikesList?.filter((row) => row.name.trim().toLowerCase().includes(e.currentTarget.value.toString().trim().toLowerCase()));
    setDisplayEbike(newDisplayFilters);
    if (e.currentTarget.value === '') setDisplayEbike(ebikesList);
    setSearchString(e.currentTarget.value);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const removeStationById = async () => {
    try {
      let response = await removeBike({ id: selectedBikeId }, authData.accessToken);
      if (response) {
        fetchData();
        setOpenDeleteEbike(false);
        props.snackbarShowMessage(response?.message);
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  const headCells = [
    {
      id: 'patients',
      numeric: false,
      disablePadding: false,
      label: labels.groups.table.header.code,
      isAction: false
    },
    {
      id: 'professionals',
      numeric: false,
      disablePadding: false,
      label: labels.groups.table.header.addingDate,
      isAction: false
    },
    {
      id: 'actions',
      numeric: false,
      disablePadding: false,
      label: labels.groups.table.header.actions,
      isAction: true
    }
  ];

  const TitleToolbarSection = styled('div')({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start'
  });

  //rendering the profile editing form
  const StationRow = ({ row, rowKey, index, handleSelectedClick }) => {
    return (
      <>
        <SpTableRow
          role="checkbox"
          id={row?.id}
          tabIndex={index}
        >
          <SpIconAndTextButton
            isIconRight={true}
            textVariant="tableText"
            text={row.code}
            onClick={() => history.push(`/admin/stations/edit/${stationId}/ebikes/edit/${row?.id}`)}
          >
            <ArrowForwardIosIcon style={{ width: 10, color: theme.colors.mainGreen.main, height: 30, cursor: 'pointer' }} />
          </SpIconAndTextButton>
          <SpTableCell>
            <SpText variant="tableText">{moment(row.createdAt).format('DD/MM/yyyy')}</SpText>
          </SpTableCell>
          <TableCell
            align={'right'}
            style={{
              padding: 0,
              verticalAlign: 'bottom',
              borderBottom: 0
            }}
          >
            <SpIconButton
              variant={'standard'}
              type="tableList"
              text={''}
              onClick={() => {
                setOpenDeleteEbike(true);
                setSelectedBikeId(row.id);
              }}
            >
              <DeleteForever />
            </SpIconButton>
          </TableCell>
        </SpTableRow>
      </>
    );
  };

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        {stationId && (
          <Grid
            item
            container
            xs={12}
            spacing={1}
            justifyContent="flex-end"
          >
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Ebike'}
                style={{ maxWidth: '40%', backgroundColor: theme.colors.mainGreen.secondary, color: 'white' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/admin/stations/edit/${stationId}/ebikes`)}
              />
            </Grid>
            {/* <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Noleggi'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/admin/stations/edit/${stationId}/rents`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Prenotazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/admin/stations/edit/${stationId}/reservations`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Segnalazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/admin/stations/edit/${stationId}/reports`)}
              />
            </Grid> */}
          </Grid>
        )}
        <Grid
          item
          container
          xs={12}
          justifyContent="space-between"
        >
          <Grid
            item
            xs={8}
          >
            <TitleToolbarSection>
              <ArrowBack
                onClick={() => history.push(`/admin/stations/edit/${stationId}`)}
                style={{ width: 25, color: theme.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
              />
              <SpText
                variant="breadcrumbs"
                style={{ marginRight: '5px' }}
              >
                {`Home / Stazione / ${currentStation?.name} / Ebikes`}
              </SpText>
            </TitleToolbarSection>
          </Grid>

          {/* {stationId ? (
						<Grid item xs={3}>
							<SpButton buttonType='accept' text={"Modifica"} style={{ width: "100%" }} variant='h1PageTitle' onClick={handleSubmit(saveStation)} />
						</Grid>
					) : (
						<Grid item xs={3}>
							<SpButton buttonType='accept' text={"Salva"} style={{ width: "100%" }} ariant='h1PageTitle' onClick={handleSubmit(saveStation)} />
						</Grid>
					)} */}
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={3}
          direction="column"
        >
          <Grid
            item
            container
            xs={12}
            direction="row"
            spacing={3}
            alignItems="center"
          >
            <Grid
              item
              xs={7}
            >
              <SpSearch
                onChange={(e) => filterEbikes(e)}
                value={searchString}
                searchStyle={{ width: '100%' }}
                style={{ marginRight: '5px' }}
              />
            </Grid>
            <Grid
              item
              xs={5}
            >
              <SpButton
                buttonType={'accept'}
                onClick={() => history.push(`/admin/stations/edit/${stationId}/ebikes/edit`)}
                text={'Aggiungi ebike'}
                style={{ marginLeft: '10%' }}
              />
            </Grid>
          </Grid>
          {displayEbike && displayEbike?.length > 0 && (
            <Grid
              item
              xs={12}
              style={{ backgroundColor: 'rgb(77, 172, 39, 0.8)' }}
            >
              <SpTable
                pagination={true}
                headCells={headCells}
                rows={displayEbike}
                rowKey="id"
                padding={false}
                notCheckable={false}
                tableContainerMaxHeight={isMobile ? 'calc(100vh - 300px)' : 'calc(100vh - 320px)'}
              >
                <StationRow />
              </SpTable>
            </Grid>
          )}
        </Grid>
      </Grid>
      <SpDialog
        style={{ padding: '1%' }}
        open={openDeleteEbike}
        setOpen={setOpenDeleteEbike}
        title={'Elimina ebike'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{"Sei sicuro di voler eliminare l'ebike?"}</SpText>
          </Grid>
          <Grid
            item
            container
            xs={12}
            alignItems={'flex-start'}
          >
            <Grid
              item
              xs={4}
            >
              <SpButton
                text={'SI'}
                buttonType="accept"
                onClick={() => removeStationById()}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ marginBottom: '1%' }}
            >
              <SpButton
                text={'NO'}
                buttonType="accept"
                onClick={() => setOpenDeleteEbike(false)}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
    </>
  );
};
export default compose(withSnackbar, withRouter)(AdminStationBikes);
